import { createReducer } from 'reducers';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
    REQUESTED,
    SUCCESSFUL,
    FAILED,
    CURRENT_VIDEO_URL,
    PUBLIC_ATHLETE_REQUEST,
    PUBLIC_ADD_CONVERSATION_REQUESTED,
    PUBLIC_ADD_CONVERSATION_FAILED,
    ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL,
    PUBLIC_ADD_CONVERSATION_SUCCESSFUL,
} from './actionTypes';

export const initialState = Map({
  profile: Map(),
  error: Map(),
  requested: false,
  videos: [],
  conversationUpdated: false,
  isLoading: false,
});

const handlers = {
  [REQUESTED](state) {
    return state.merge({
      conversationUpdated: false,
      requested: true,
      error: Map(),
      isLoading: true,
    });
  },
  [FAILED](state, action) {
    return state.merge({
      requested: false,
      error: action.error,
    });
  },
  [SUCCESSFUL](state, action) {
    return state.merge({
      requested: false,
      profile: action.profile,
      error: Map(),
      isLoading: false,
    });
  },
  [PUBLIC_ATHLETE_REQUEST](state, action) {
    return state.merge({
      requested: false,
      request: action.request,
      error: Map(),
      isLoading: false,
    });
  },

  [PUBLIC_ADD_CONVERSATION_REQUESTED](state) {
    return state.merge({
      requested: true,
      conversationUpdated: false,
    });
  },
  [PUBLIC_ADD_CONVERSATION_SUCCESSFUL](state) {
    return state.merge({
      conversationUpdated: false,
    });
  },
  [PUBLIC_ADD_CONVERSATION_FAILED](state, action) {
    return state.merge({
      requested: true,
      conversationUpdated: true,
      error: action.error,
    });
  },
  [ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL](state, action) {
    return state.merge({
      requested: false,
      request: action.data.get('Attributes'),
      conversationUpdated: true,
    });
  },
  [SESSION_LOGOUT](state) {
    return state.merge({
      profile: Map(),
      error: Map(),
      requested: false,
      videos: [],
      isLoading: false,
    });
  },
  [CURRENT_VIDEO_URL](state, action) {
    return state.merge({
      currentVideoUrl: action.url,
    });
  },
};

export const publicAthlete = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getError = state => state.publicAthlete.get('error');
const getProfile = state => state.publicAthlete.get('profile');
const getRequest = state => state.publicAthlete.get('request');
const IsRequested = state => state.publicAthlete.get('requested');
const CurrentVideo = state => state.publicAthlete.get('currentVideoUrl');
const getConversationUpdated = state => state.publicAthlete.get('conversationUpdated');

export const selector = createStructuredSelector({
  error: getError,
  profile: getProfile,
  request: getRequest,
  requested: IsRequested,
  currentVideoUrl: CurrentVideo,
  conversationUpdated: getConversationUpdated,
});



// WEBPACK FOOTER //
// ./src/containers/PublicAthletePage/redux.js